export interface KeyNumber {
  value: string;
  label: string;
  source?: string;
}

export interface GuideSubsection {
  heading: string;
  body: string;
}

export interface GuideSection {
  heading: string;
  body: string;
  level?: 'h2' | 'h3';
  subsections?: GuideSubsection[];
}

export interface GuideFaq {
  question: string;
  answer: string;
}

export interface GuideArticle {
  slug: string;
  title: string;
  metaDescription: string;
  datePublished: string;
  dateModified: string;
  author: string;
  keyNumbers: KeyNumber[];
  intro: string;
  sections: GuideSection[];
  faqs?: GuideFaq[];
}

import dbGuidesData from './_db_guides.json';

const dbGuides = dbGuidesData as unknown as GuideArticle[];

export const GUIDES: GuideArticle[] = [...dbGuides];

export function findGuide(slug: string): GuideArticle | undefined {
  return GUIDES.find((g) => g.slug === slug);
}
